import { AccessibilityPaneComponent } from "widgets-module/components/accessibility-pane/accessibility-pane.component";
import { CountdownTimerComponent } from "widgets-module/components/countdown-timer/countdown-timer.component";
import { FavouritesControl } from "widgets-module/components/favourites/favourites-control.service";
import { FavouritesListControlService } from "widgets-module/components/favourites/favourites-list-control.service";
import { MapComponent } from "widgets-module/components/map/map.component";
import { NavigationBarComponent } from "widgets-module/components/navigation-bar/navigation-bar.component";
import { NotificationService } from "widgets-module/components/notification/notification.service";
import { SmartSuggestComponent } from "widgets-module/components/smart-suggest/smart-suggest.component";
import { SlickSliderComponent } from "widgets-module/components/slick-slider/slick-slider.component";
import { DatePickerComponent } from "widgets-module/components/date-picker/date-picker.component";
import { AssistantContactFormComponent } from "widgets-module/components/assistant-contact-form/assistant-contact-form.component";
import { CharacterCounter } from "widgets-module/components/character-counter/character-counter.component";
import { ImageUploadPreviewComponent } from "widgets-module/components/image-upload-preview/image-upload-preview.component";
import { HidePageButton } from "widgets-module/components/hide-page-button/hide-page-button.component";
import { SavePage } from "widgets-module/components/save-page/save-page.component";
import {PieChartComponent} from "./components/charts/pie-chart/pie-chart.component";
import {BarChartComponent} from "./components/charts/bar-chart/bar-chart.component";
import {PageRatingComponent} from "./components/page-rating/page-rating.component";

class FrontendModule {
    public init(): void {
        $.extend($, {
            pcg: {
                frontend: {
                    accessibilityPane: AccessibilityPaneComponent,
                    assistantContactForm: AssistantContactFormComponent,
                    characterCounter: CharacterCounter,
                    countdownTimer: CountdownTimerComponent,
                    datePicker: DatePickerComponent,
                    favouritesControl: new FavouritesControl(),
                    favouritesListService: new FavouritesListControlService(),
                    hidePageButton: HidePageButton,
                    imageUploadPreview: ImageUploadPreviewComponent,
                    map: MapComponent,
                    navigationBar: NavigationBarComponent,
                    notificationService: new NotificationService(),
                    slickSlider: SlickSliderComponent,
                    smartSuggest: SmartSuggestComponent,
                    savePage:SavePage,
                    pieChart: PieChartComponent,
                    barChart: BarChartComponent,
                    pageRating: PageRatingComponent
                }
            }
        });
    }
}

export const frontend = new FrontendModule();
